module.exports = __webpack_public_path__ + "img/h5img41.592bf939.png";